define((require) => {
    "use strict";

    const KeyCode    = require("shared/services/KeyCode");
    const Backbone   = require("backbone");
    const Marionette = require("marionette");
    const TagView    = require("components/tag_input/TagView");
    const template   = require("components/tag_input/TagInputView.tpl");

    const SEPARATOR = [KeyCode.COMMA, KeyCode.ENTER, KeyCode.RETURN];

    /**
     * A tags input is a component of input box that automatically creates tags – also called tokens
     * It's useful for tagging and highlighting information right on the input box, providing an ease of use of UX
     *
     * This component provides the functionality like auto tag creation, edit and delete in place. But due to the
     * special requirement, the tag is designed as non-deletable after saved.
     *
     * @class TagInputView
     * @author Yijie Li
     */
    return Marionette.CompositeView.extend({

        className: "tag-input",

        template,

        itemView: TagView,

        itemViewContainer: ".tags",

        options: {
            propName: "tags"
        },

        ui: {
            input: ".input"
        },

        events: {
            "keydown .input": "_handleKeyEvents",
            "blur .input": "_processInput",
            "click": "_focusInput"
        },

        collectionEvents: {
            "add remove change": "_collectionChangeHandler"
        },

        constructor(options) {
            if (!options.collection) {
                options.collection = new Backbone.Collection();
            }

            this.__super(options);
        },

        itemViewOptions() {
            return {
                propName: this.options.propName
            };
        },

        _collectionChangeHandler() {
            this._updateClassName();

            const {propName} = this.options;
            // Construct list of tags to be dispatched, excluding empty
            // strings (might happen if you start inline editing).
            const tags = this.collection
                .chain()
                .map((model) => (model.get(propName)))
                .filter((tag) => (tag.length > 0))
                .value();

            this.triggerMethod("change", tags);
        },

        _focusInput() {
            this._updateClassName(true);
            this.ui.input.focus();
        },

        _handleKeyEvents(event) {
            if (SEPARATOR.indexOf(event.keyCode) !== -1) {
                this._processInput();
                event.preventDefault();
            }
        },

        _updateClassName(state) {
            state = state || this.collection.models.length > 0;
            this.$el.toggleClass("has-tags", state);
        },

        _processInput() {
            const input = this.ui.input.text();
            const names = input.split(",");
            const [name] = names;
            const findQuery = {};

            findQuery[this.options.propName] = name;

            const exists = this.collection.findWhere(findQuery) !== undefined;

            if (name && name.trim() && !exists) {
                this.addTag(name);
                this.ui.input.text("");
            }

            this._updateClassName();
        },

        addTag(tag) {
            if (this.options.limit && this.collection.models.length >= this.options.limit) {
                return;
            }

            const tagModel = {
                [this.options.propName]: tag
            };

            this.collection.add(new this.collection.model(tagModel));
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/components/tag_input/TagInputView.js